import { render } from "./UserSearch.vue?vue&type=template&id=2d76452c&scoped=true&lang=pug"
import script from "./UserSearch.vue?vue&type=script&lang=js"
export * from "./UserSearch.vue?vue&type=script&lang=js"

import "./UserSearch.vue?vue&type=style&index=0&id=2d76452c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d76452c"]])

export default __exports__